import type { PriceInfoTexusType } from "../types/TexusTypes";

export enum EquipmentAvailabilityEnum {
    NotAvailable = 0,
    Standard = 1,
    Optional = 2,
}

export enum TexusPackType {
    Finance = "Finance",
    Equipment = "Equipment",
}

export const texusPackTypeMapping: Record<TexusPackType, number> = {
    [TexusPackType.Equipment]: 1,
    [TexusPackType.Finance]: 2,
};

export type EquipmentAvailabilityType = {
    id: string;
    availability: EquipmentAvailabilityEnum;
    priceInfo: PriceInfoTexusType;
};
